/* Something Doggy — Scroll reveal for sd-reveal elements */
(function () {
  if (window.__sdRevealInit) return;
  window.__sdRevealInit = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.sd-reveal').forEach(function (el) {
      el.classList.add('sd-revealed');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sd-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.05, rootMargin: '0px 0px -20px 0px' }
  );

  function observeAll() {
    document.querySelectorAll('.sd-reveal:not(.sd-revealed)').forEach(function (el) {
      observer.observe(el);
    });
  }

  observeAll();

  new MutationObserver(function () { observeAll(); })
    .observe(document.body, { childList: true, subtree: true });
})();
